import SetState from 'Components/Hooks/SetState'
import ButtonInsideBox from 'Components/UI/Atoms/ButtonInsideBox'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'

import WafersContent from './Content'
//import ConceptsContent from './Content'

const Wafers = () => {
  const { setOpen, setClose, state } = SetState()

  return (
    <>
      <ButtonInsideBox
        onClick={setOpen}
        text="Obleas"
        button="Configurar"
        img={process.env.PUBLIC_URL + '/Images/wafers.png'}
      />

      <DialogComponent
        disableBackdropClick
        disableEscapeKeyDown
        widthLarge="25vw"
        title="Obleas"
        open={state.open}
        handleclose={setClose}
        maxHeight
        children={<WafersContent />}
      />
    </>
  )
}

export default Wafers
